import { API_URL } from '../config';
import { API_PATHS } from '../Constants';

const saveEmail = (email, notifyEmail) => fetch(`${API_URL}/${API_PATHS.EMAILS}`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ email, notifyEmail }),
}).then(res => res.json());

const getData = (offset, limit) => fetch(`${API_URL}/${API_PATHS.EMAILS}/?offset=${offset}&limit=${limit}`)
  .then(res => res.json());

const getNotificationEmails = () => fetch(`${API_URL}/${API_PATHS.NOTIFICATION_EMAILS}`)
  .then(res => res.json());

const saveNotificationEmails = email => fetch(`${API_URL}/${API_PATHS.NOTIFICATION_EMAILS}`, {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
  },
  body: JSON.stringify({ email }),
}).then(res => res.json());

const deleteNotificationEmail = email => fetch(`${API_URL}/${API_PATHS.NOTIFICATION_EMAILS}/${email}`, {
  method: 'DELETE',
  headers: {
    'Content-Type': 'application/json',
  },
});

export {
  saveEmail,
  getData,
  getNotificationEmails,
  saveNotificationEmails,
  deleteNotificationEmail,
};
